/*
 * Copyright (c) CIRROM 2025.
 */

import React from "react";
import { CircularProgress, Box } from "@mui/material";

export const LoadingDisplay: React.FC = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="400px"
    >
      <CircularProgress size={60} />
    </Box>
  );
};
